import { atomWithReset } from 'jotai/utils';

import { NetSuiteInvoiceListItemExpanded } from '../data/types/NetSuiteInvoiceItems';
import { NetSuiteInvoiceFields } from './NetSuiteInvoiceRequestForm.types';

export const netSuiteInvoiceItemListState = atomWithReset<NetSuiteInvoiceListItemExpanded[]>([]);

export const netSuiteInvoiceFieldValuesState = atomWithReset<Partial<NetSuiteInvoiceFields>>({});
